import { IProps } from '@/Interfaces/Icons/Props.interface';

const TuneIcon = ({ className, ...props }: IProps) => {
  return (
    <svg
      className={className}
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.52083 7.91667C9.05112 7.91667 10.2917 6.67612 10.2917 5.14583C10.2917 3.61554 9.05112 2.375 7.52083 2.375C5.99054 2.375 4.75 3.61554 4.75 5.14583C4.75 6.67612 5.99054 7.91667 7.52083 7.91667Z'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.4798 16.6257C13.0101 16.6257 14.2507 15.3851 14.2507 13.8548C14.2507 12.3245 13.0101 11.084 11.4798 11.084C9.94953 11.084 8.70898 12.3245 8.70898 13.8548C8.70898 15.3851 9.94953 16.6257 11.4798 16.6257Z'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.625 13.8535H14.25'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.70833 13.8535H2.375'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.6243 5.14648H10.291'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.75 5.14648H2.375'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TuneIcon;
